import { Injectable } from '@angular/core';
import { EnvironmentService } from '../../services/environment.service';
import { TokenService } from './oauth.service';

@Injectable()
export class HeaderService {
  constructor(private readonly tokenService: TokenService, private readonly environmentService: EnvironmentService) {}

  /**
   * Accept-Language header's value.
   *
   * @private
   * @memberof HeaderService
   * @default 'en'
   */
  private locale = 'en';

  /**
   * Gets the header with the Authentication header.
   *
   * @readonly
   * @memberof HeaderService
   */
  public get header() {
    const headersConfig = {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin':
        this.environmentService && this.environmentService.environment
          ? this.environmentService.environment.apiUrl
          : '*',
      Accept: 'application/json',
    };

    headersConfig['Accept-Language'] = this.locale;

    if (this.tokenService.hasToken()) {
      headersConfig['Authorization'] = `Bearer ${this.tokenService.getToken()}`;
    }

    return headersConfig;
  }

  public get fileHeader() {
    const headersConfig = this.header;

    delete headersConfig['Content-Type'];

    return headersConfig;
  }

  /**
   * This function sets the Accept-Language's value.
   *
   * @param {string} locale
   * @memberof HeaderService
   */
  public setLocale(locale: string) {
    this.locale = locale;
  }
}
